export enum ToastrType {
    Info = 1,
    Success,
    Error,
    Warning,
}
